import { useFormik } from "formik";
import { isEmpty } from "ramda";
import React, { useContext, useEffect, useState } from "react";
import { HiOutlineUserCircle } from "react-icons/hi";
import * as yup from "yup";
import { ToastContext } from "../../../contexts/ToastContext";
import { mutation1 } from "../../../services/graphqlService";
import { ToastType } from "../../../utils/enums/ToastType";
import { ShadowInput } from "../../ShadowInput";
import { ProfileEditModal } from "../ProfileEditModal";

export const LastNameEditModal = ({
  open,
  setOpen,
  userId,
  mergeUser,
  lastName,
}) => {
  const [loading, setLoading] = useState(false);
  const { addToast } = useContext(ToastContext);
  const editForm = useFormik({
    initialValues: {
      lastName: "",
    },
    validationSchema: yup.object({
      lastName: yup.string().required("A new last name is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const {
          data: { updateUser },
        } = await mutation1(`updateUser(id: ${userId}, data: { lastName: "${values.lastName}" }) {
                lastName
            }`);

        mergeUser(updateUser);
        setLoading(false);
        editForm.resetForm();
        setOpen(false);
      } catch (err) {
        addToast(
          ToastType.Error,
          "Action failed. The server may be temporarily down. Please try again in a few minutes."
        );
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (open && !isEmpty(lastName)) {
      editForm?.setFieldValue("lastName", lastName, false);
    }
    //eslint-disable-next-line
  }, [lastName, open]);

  return (
    <ProfileEditModal
      open={open}
      setOpen={setOpen}
      header="Update your last name"
      onSubmit={editForm.handleSubmit}
      onClose={() => editForm.setFieldValue("lastName", lastName)}
      loading={loading}
    >
      <form className="flex flex-col space-y-3 px-10 mt-5">
        <ShadowInput
          id="lastName"
          name="lastName"
          placeHolder="Last Name"
          // label="Last Name"
          onChange={editForm.handleChange}
          onBlur={editForm.handleBlur}
          error={editForm.errors.lastName}
          value={editForm.values.lastName}
          touched={editForm.touched.lastName}
          icon={<HiOutlineUserCircle className="text-2xl text-gray-400" />}
        />
      </form>
    </ProfileEditModal>
  );
};
